// extracted by mini-css-extract-plugin
module.exports = {"icon-plus":"_4-YS+hK0FjrFp62HlmOD3w==","iconPlus":"_4-YS+hK0FjrFp62HlmOD3w==","button":"Z6CSrvscOk7T8nZsiv8F2Q=="};